module.exports = __webpack_public_path__ + "static/media/GTBSProjectPreview2w1100@1x.c44de8f5.jpeg";